import { Observable } from 'rxjs'
import io from 'socket.io-client'

import config from '../common/config'

export async function notificationSocket() {
  const query = `token=JWT ${await config.auth.getTokenString()}`

  const ioNotification = io.connect(config.url.api('/notifications'), {
    query,
    transports: ['websocket', 'polling', 'flashsocket'],
  })

  return Observable.create((observer) => {
    ioNotification.on('updated', (notification) => {
      observer.next(notification)
    })
  })
}
